export const bigTilesParalax = () => {
  const tilesWrapper = document.querySelector('.js-bigTiles-pannelWrapper') as unknown as HTMLElement
  const allTiles = document.querySelectorAll('.js-bigTiles-pannel') as unknown as HTMLElement[]
  const skipButton = document.querySelector('.js-bigTiles-skipButton') as unknown as HTMLElement

  if (!tilesWrapper || !allTiles) return

  let wrapperHeight = 0
  let highestTile = 0
  let triggeredScroll = false
  let lastCheck = false
  let extraTileScrollDistance = window.innerHeight * 0.4

  let tilesDataArray: {
    tile: HTMLElement,
    offsetTop: number,
    textContent: HTMLElement,
    imageContent: HTMLElement
  }[] = []

  const recalculateTiles = () => {
    tilesWrapper.style.paddingBottom = '0'
    tilesWrapper.style.marginTop = `-${extraTileScrollDistance * 2}px`
    tilesWrapper.style.marginBottom = `${extraTileScrollDistance * 2}px`
    tilesDataArray = []
    wrapperHeight = 0
    highestTile = 0

    // Reset styles
    allTiles.forEach(tile => {
      // @ts-ignore
      tile.style = ''
    })

    // Recalculate styles
    allTiles.forEach(tile => {
      highestTile = (highestTile < tile.offsetHeight)
        ? tile.offsetHeight
        : highestTile
      tilesDataArray.push({
        tile: tile,
        offsetTop: tile.getBoundingClientRect().top + window.scrollY,
        imageContent: tile.querySelector('.js-bigTiles-pannelImageContent') as unknown as HTMLElement,
        textContent: tile.querySelector('.js-bigTiles-pannelTextContent') as unknown as HTMLElement
      })
    })

    allTiles.forEach((tile, index) => {
      tile.style.height = `${highestTile}px`
    })

    allTiles.forEach((tile, index) => {
      tilesDataArray[index].offsetTop = tile.getBoundingClientRect().top + window.scrollY + extraTileScrollDistance
    })
    wrapperHeight = (((highestTile + extraTileScrollDistance) * tilesDataArray.length) + window.innerHeight) + extraTileScrollDistance * 2
    tilesWrapper.style.paddingBottom = `${wrapperHeight}px`
  }

  const handlePositionOfTiles = () => {
    let noTileInView = true
    tilesDataArray.forEach((tile, index) => {
      tile.tile.style.position = 'fixed'

      // @ts-ignore
      const headerHeight = document.querySelector('.js-header-menuControlLine')?.offsetHeight || 0

      const windowPadding = (window.innerHeight / 100 * 10 > headerHeight)
        ? window.innerHeight / 100 * 10
        : parseInt(headerHeight)

      const extraViewportPadding = (window.innerHeight - windowPadding > highestTile)
        ? (window.innerHeight - highestTile - windowPadding) / 2
        : 0

      // If the tile is in the viewport
      if (tile.offsetTop - highestTile - windowPadding < window.scrollY - (extraTileScrollDistance * (index + 1))) {
        const scrolled = Math.abs(tile.offsetTop - highestTile - window.scrollY - windowPadding - extraViewportPadding + (extraTileScrollDistance * (index + 1)))

        tile.tile.style.bottom = `${extraViewportPadding}px`

        noTileInView = false

        // If the tile is currently in focus
        if (scrolled <= highestTile) {
          tile.tile.style.transform = `translateY(${highestTile - scrolled}px)`
          tile.tile.style.opacity = '1'

          tile.tile.classList.add('-inView')

          let bonusScrollAmount = 0

          // Normal scaling
          if (window.innerWidth > 1920 && index !== 0) {
            bonusScrollAmount = 600
          }
          if (window.innerWidth <= 1920 && index !== 0) {
            bonusScrollAmount = 300
          }

          // Scaling for first tile
          if (window.innerWidth > 1920 && index === 0) {
            bonusScrollAmount = 200
          }
          if (window.innerWidth <= 1920 && index === 0) {
            bonusScrollAmount = 100
          }

          if (highestTile - scrolled < bonusScrollAmount) {
            tile.tile.style.transform = 'translateY(0px)'
            tile.tile.style.transition = 'transform 0.6s linear'

            setTimeout(() => {
              tile.tile.style.transition = ''
            }, 100)
          }

          /*  const contentTranslateValue = (100 - ((scrolled / highestTile) + 0.2) * 100) >= 0
            ? 100 - ((scrolled / highestTile) + 0.2) * 100
            : 0

          tile.textContent.style.transform = `translateX(-${contentTranslateValue}%)`
          tile.imageContent.style.transform = `translateX(${contentTranslateValue}%)` */
        }
        // If the tile is NOT in focus
        else if (scrolled > highestTile + extraTileScrollDistance) {
          const computedOpacity = (2 - (scrolled / (highestTile + extraTileScrollDistance)))
          const computedScale = (2 - (scrolled / (highestTile + extraTileScrollDistance)) > 1)
            ? 1
            : 2 - (scrolled / (highestTile + extraTileScrollDistance))

          // A bit of padding for big scroll distances
          if (computedOpacity >= -0.5 && computedOpacity <= 1.5) {
            tile.tile.style.opacity = computedOpacity.toString()
            tile.tile.style.transform = `translateY(0px) scale(${computedScale})`
          }
        }
      }

      // If the tile is NOT in the viewport
      else {
        tile.tile.style.bottom = '0px'
        tile.tile.style.transform = 'translateY(110%)'
      }
    })

    if (noTileInView) {
      skipButton.classList.remove('-inView')
      tilesDataArray.forEach((tile, index) => {
        tile.tile.classList.remove('-inView')
      })
    }
    else {
      skipButton.classList.add('-inView')
    }
  }

  const finishScrollingCheck = () => {
    const wrapperTriggerPoint = tilesWrapper.getBoundingClientRect().top + tilesWrapper.offsetHeight + window.scrollY + extraTileScrollDistance

    if (wrapperTriggerPoint <= window.scrollY + window.innerHeight && lastCheck === false) {
      cleanupAfterScrolling()
    }
  }

  const cleanupAfterScrolling = () => {
    lastCheck = true
    tilesWrapper.remove()
    skipButton.remove()
    const wrapperElement = document.querySelector('.js-bigTiles') as unknown as HTMLElement
    wrapperElement.style.opacity = '0'
    wrapperElement.scrollIntoView({
      behavior: 'auto',
      block: 'start'
    })
    setTimeout(() => {
      wrapperElement.style.transition = 'opacity 0.6s ease-in'
      wrapperElement.style.opacity = '1'
      window.scrollBy(0, -400)
    }, 50)
  }

  const firstSetupTiles = () => {
    tilesDataArray.forEach((tile) => {
      tile.tile.classList.remove('-noAnimation')
    })
  }

  // On Manual skip
  skipButton.addEventListener('click', cleanupAfterScrolling)

  // On scroll
  window.addEventListener('scroll', () => {
    setTimeout(() => {
      if (window.innerWidth > 1365 && triggeredScroll === false && lastCheck === false) {
        triggeredScroll = true

        handlePositionOfTiles()
        finishScrollingCheck()

        setTimeout(() => {
          triggeredScroll = false
        }, 100)
      }
    }, 100)
  })

  window.addEventListener('wheel', () => {
    setTimeout(() => {
      if (window.innerWidth > 1365 && triggeredScroll === false && lastCheck === false) {
        triggeredScroll = true

        handlePositionOfTiles()
        finishScrollingCheck()

        setTimeout(() => {
          triggeredScroll = false
        }, 100)
      }
    }, 100)
  })

  // On resize
  window.addEventListener('resize', () => {
    if (window.innerWidth > 1365 && triggeredScroll === false && lastCheck === false) {
      triggeredScroll = true

      setTimeout(() => {
        recalculateTiles()
        handlePositionOfTiles()
        finishScrollingCheck()

        setTimeout(() => {
          triggeredScroll = false
        }, 100)
      }, 100)
    }
  }
  )

  if (window.innerWidth > 1365) {
    recalculateTiles()
    handlePositionOfTiles()
    finishScrollingCheck()
    firstSetupTiles()
  }
}
